export const REF_NAME = 'BUYER';
export const REF_PATH = 'buyer';
export const NAME = 'Buyer';
